import React, { useEffect, useState } from 'react';

import { ChatIcon } from './ChatIcon';
import { SupportPopup } from './SupportPopup';
import * as styles from './styles.module.scss';
import {
  initZendeskCustomLauncher,
  openZendeskContactFormWhenReady,
  openZendeskWidgetWhenReady,
} from '../../utils/zendesk';

export const ZendeskChatButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    initZendeskCustomLauncher();
  }, []);

  const handleChatClick = () => {
    setIsOpen(prev => !prev);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const openZendeskSafely = (openWidget: () => void) => {
    window.setTimeout(() => {
      try {
        openWidget();
      } catch {
        // Zendesk widget scripts can throw cross-origin errors in development.
      }
    }, 0);
  };

  const handleHelpCenter = () => {
    setIsOpen(false);
    openZendeskSafely(openZendeskWidgetWhenReady);
  };

  const handleSupportForm = () => {
    setIsOpen(false);
    openZendeskSafely(openZendeskContactFormWhenReady);
  };

  return (
    <>
      <SupportPopup
        open={isOpen}
        onClose={handleClose}
        onHelpCenter={handleHelpCenter}
        onSupportForm={handleSupportForm}
      />

      <button
        type="button"
        className={styles.button}
        aria-label="Open help chat"
        aria-expanded={isOpen}
        aria-controls="support-popup"
        onClick={handleChatClick}>
        <ChatIcon size={32} />
      </button>
    </>
  );
};
